import req from '../http';
import urls from '../../utils/config';
const baseURL = process.env.NODE_ENV == 'development' ? process.env.VUE_APP_URL: urls['url']

export const selectById = params => req('post', '/config/information/selectById', params, {
  baseURL
}); // 消息详情
export const djSelectById = params => req('post', '/config/msgV2/msgDetail', params, {
    baseURL
  }); // 代驾司机消息详情
